/* eslint-disable class-methods-use-this */
import sjcl from 'sjcl';
import { authProvider } from '../../auth/authProvider';

const currentCache = 'Saipem_v42';
const iv = sjcl.codec.hex.toBits('AD521E70 4A33B40D ED037F86 0AC3D66F');
const key = sjcl.codec.hex.toBits(
  'D74ECC7D 2631AC9C 3F90123E F85A5CC4 32608A87 8E16A923 FC921F25 6DB013C6'
);
const salt = sjcl.codec.hex.toBits('FF7DC46B 7BB1B8FB');

function encrypt(plainText) {
  const cryptoObj = {
    iv: sjcl.codec.base64.fromBits(iv),
    v: 1,
    iter: 10000,
    ks: 256,
    ts: 64,
    mode: 'ccm',
    adata: '',
    cipher: 'aes',
    salt: sjcl.codec.base64.fromBits(salt),
  };
  const encryptedObj = sjcl.encrypt(key, JSON.stringify(plainText), cryptoObj).replace(/,/g, ',\n');
  const encryptedText = JSON.parse(encryptedObj).ct;
  return encryptedText;
}

function decrypt(encryptedText) {
  const encryptedArray = sjcl.codec.base64.toBits(encryptedText);
  const aes = new sjcl.cipher.aes(key);
  const plaintext = sjcl.codec.utf8String.fromBits(sjcl.mode.ccm.decrypt(aes, encryptedArray, iv));
  return plaintext;
}

async function putCache(url, data) {
    console.log(`CacheStorage.putCache: url:  ${url}`);
    try {
        const cache = await caches.open(currentCache);
        await cache.put(url, new Response(data));
    } catch (err) {
        console.error("CacheStorage.putCache: Error adding to Cache: ", { ...err, url })
    }
}

class CacheStorage {
    async updateCache(data, url) {
        console.log(`CacheStorage.updateCache: url:  ${url}`);
        try {
            await putCache(url, encrypt(data)); // JSON.stringify(data));
        } catch (err) {
            console.error("CacheStorage.updateCache: Error Updating Cache: ", {...err, url})
        }
    }

    async flushQueue() {
        console.log(`CacheStorage.flushQueue`);
        try {
            const token = await authProvider.getAccessToken();
            if (token) {
                navigator.serviceWorker.ready.then((swRegistration) =>
                    swRegistration.sync.register(`flushQueue-Bearer ${token.accessToken}`)
                );
            }
        } catch (err) {
            console.error("CacheStorage.flushQueue: Error flushing queue: ", { ...err });
        }
    }

    async getQueueLength() {
        navigator.serviceWorker.ready.then((swRegistration) =>
            swRegistration.sync.register('queueLength')
        );
    }

    async getFromCache(url) {
        console.log(`CacheStorage.getFromCache: url:  ${url}`);
        try {
            const cache = await caches.open(currentCache);
            if (cache) {
                const cachedResponse = await cache.match(url);
                if (cachedResponse) {
                    const cryptedResponse = await cachedResponse.text();
                    const decryptedResponse = decrypt(cryptedResponse); // cryptedResponse;
                    console.log(`CacheStorage.getFromCache: cache fetched.`);
                    return JSON.parse(decryptedResponse);
                }
                return undefined;
            }
            return undefined;
        } catch(err) {
            console.error("CacheStorage.getFromCache: Error Getting From Cache: ", {...err, url})
        }
    }
}

export default CacheStorage;
